// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DeactivatePaymentRuleResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/deactivate_payment_rule endpoint
 *
 * Action endpoint — confirms successful deactivation of a payment rule.
 * No payload: dados is always null on success; failures route through
 * sendError() and never reach this contract.
 *
 * @see Payroll::deactivate_payment_rule() controller
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_DeactivatePaymentRuleResponseDados = null;

export type Payroll_DeactivatePaymentRuleResponse = ApiResponse<Payroll_DeactivatePaymentRuleResponseDados>;

registerResponseContract('Payroll_DeactivatePaymentRuleResponse', {})
